import { CanActivateFn } from '@angular/router';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { NgxSpinnerService } from "ngx-spinner";

@Injectable({
  providedIn: 'root'
})

// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };


export class AuthGuard {
  VadlidUer = false;
  

  constructor(private authService: AuthService, private router: Router, private spinner: NgxSpinnerService) { };

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.VadlidUer) {
      return true;
    } else {
      return this.authService.ValidateToken().pipe(
        map(data => {
          // if (data === false) {
          //   this.VadlidUer = false;
          //   this.router.navigate(['/login-failed']);
          //   return false;
          // }
          if(data.success==true){
            this.spinner.hide();
            this.VadlidUer = true;
            this.authService.setUserData(data.data);
            this.authService.setUserId(data?.data?.userId);
            this.authService.processRolePermission(data?.data)
            return true;
          }else{
            this.notValidUser();
            return false;
          }
          
        }),
        catchError((): any => {
          this.notValidUser();
          return false;
        }),
      );
    }
  }

   notValidUser(){
    this.spinner.hide();
    this.VadlidUer = false;
    // this.router.parseUrl('/login-failed');
    this.router.navigateByUrl('/login-failed');
   }
  public canActivate1(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let loginRes: any = this.authService.ValidateToken2();
      if(loginRes) {
        return true;
      } else {
        this.router.navigate(['/login-failed']);
        return false;
      }
    
  }
  

  // async checkValidateToken() {
  //   this.authService.ValidateToken()
  //     .subscribe({
  //       next: (res: any) => {
  //         this.spinner.hide();
  //         this.VadlidUer = true;
  //         return true;
  //       },
  //       error: (err: any) => {
  //         this.spinner.hide();
  //         this.VadlidUer = false;
  //         this.router.navigate(['/login-failed']);
  //         return false;
  //       }
  //     })
  // }

}

